var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.952 53.056C41.952 47.712 44.032 42.688 47.808 38.912C51.584 35.136 56.608 33.056 61.952 33.056H61.984L34.048 10.048C33.632 9.69599 33.056 9.53599 32.544 9.59999C32 9.56799 31.456 9.69599 31.04 10.048L1.59995 33.984C0.767954 34.656 0.703954 35.808 1.43995 36.576L4.95995 40.224C5.69595 40.992 6.94395 41.056 7.77595 40.384L9.82395 38.72V70.432H25.952V48.384H38.656V70.432H52.128C50.592 69.568 49.152 68.48 47.872 67.2C44.032 63.424 41.952 58.4 41.952 53.056Z",
    fill: "#750AAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2399 40.8C71.1039 37.664 66.7519 35.712 61.9839 35.712C57.1839 35.712 52.8639 37.664 49.7279 40.8C46.5919 43.936 44.6399 48.288 44.6399 53.056C44.6399 57.856 46.5919 62.176 49.7279 65.312C52.8639 68.448 57.2159 70.4 61.9839 70.4C66.7839 70.4 71.1039 68.448 74.2399 65.312C77.3759 62.176 79.3279 57.824 79.3279 53.056C79.3279 48.288 77.3759 43.936 74.2399 40.8ZM60.3839 42.368L60.4159 40.448L63.4559 40.416L63.5199 42.368L69.5679 43.872L67.8719 48.128C67.8719 48.128 64.5759 47.072 63.9039 46.88C62.1759 46.4 59.9359 46.368 59.9039 47.872C59.8719 49.504 64.1919 50.368 66.6239 51.616C71.2959 54.016 71.1359 60.544 65.6319 62.336C65.0559 62.528 63.6479 62.816 63.6159 62.816L63.4879 65.664H60.3839L60.3519 62.88C60.3519 62.88 58.0479 62.656 56.9279 62.4C55.8079 62.144 53.9519 61.472 53.9519 61.472V56.48C64.1919 60.768 66.0159 57.344 62.1439 55.488C59.2639 54.112 53.0879 53.12 54.0159 47.168C54.7519 42.784 60.3519 42.4 60.3839 42.368Z",
    fill: "#750AAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21L55 27.5L61.5 33L68.5 26.5L73 31L76 13L58 16L63 21Z",
    fill: "#750AAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuation);
export default __webpack_public_path__ + "static/media/valuation.55995c36ea2a1f7dc25be15588c12ec4.svg";
export { ForwardRef as ReactComponent };